<template>
  <svg :style="svgStyle">
    <measure-skeleton-line
      :crop="crop"
      v-for="(line, index) in getLines"
      :key="index"
      :startPoint="line.startPointName"
      :endPoint="line.endPointName"
      :projection="projection"
      :zoom="zoom"
      :heightZoom="heightZoom"
      :width="width"
      :isActive="activeLine(line)"
    />
  </svg>
</template>

<script>
import { mapGetters } from "vuex";
import MeasureSkeletonLine from "./measure-skeleton-line.vue";

export default {
  components: {
    MeasureSkeletonLine
  },
  props: {
    projection: String,
    crop: Object,
    zoom: Number,
    heightZoom: Number,
    addTopZero: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 750
    }
  },
  computed: {
    ...mapGetters(["getLines", "getArea", "getPictureHeight"]),
    svgStyle() {
      return {
        height: this.getPictureHeight * this.heightZoom + "px",
        top: this.addTopZero ? "0px" : "",
        width: this.width * this.heightZoom + "px"
      };
    }
  },
  methods: {
    activeLine(line) {
      return this.getArea.handles.some(
        activePoint =>
          activePoint.puppetPointName === line.startPointName ||
          activePoint.puppetPointName === line.endPointName
      );
    }
  }
};
</script>
